import React, {PureComponent, StrictMode} from "react";
import {Brand} from "@App/types";
import {CarOutlineGrey} from "@App/Components/common/Icons";

type BrandListItemProps = {
    brand: Brand
    onClick: (brand: Brand) => void
}

export class BrandListItem extends PureComponent<BrandListItemProps> {
    render() {
        return (
            <StrictMode>
                <div
                    className="w-full flex gap-3 p-3 border-b border-neutral-100 cursor-pointer items-center"
                    onClick={() => this.props.onClick(this.props.brand)}>
                    {this.props.brand.logo && (
                        <img src={"/storage/" + this.props.brand.logo} className={'w-8 shrink-0'}
                             alt={`${this.props.brand.name} Logo`}/>
                    )}
                    {!this.props.brand.logo && (
                        <CarOutlineGrey className={'w-8 shrink-0'}/>
                    )}
                    <span className="text-neutral-700">{this.props.brand.name.toUpperCase()}</span>
                </div>
            </StrictMode>
        );
    }
}
